// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewFolderInput {
  display: flex;
  justify-content: space-between;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 12px;
}
.NewFolderInput > div:first-child:not(.NewFolderInput-reachedLimit-container) {
  flex: 1 1;
  padding-left: 12px;
}
.NewFolderInput .NewFolderInput-actions-wrapper {
  display: flex;
}
.NewFolderInput .NewFolderInput-button-wrapper {
  display: flex;
  align-items: center;
  column-gap: 16px;
}
.NewFolderInput .NewFolderInput-button-wrapper .NewFolderInput-limit {
  font-size: 10px;
  font-weight: var(--regular_weight);
  transition: 0.16s ease-in-out;
  opacity: 0;
}
.NewFolderInput .NewFolderInput-button-wrapper .NewFolderInput-button {
  font-size: 12px;
}
.NewFolderInput .NewFolderInput-button-wrapper .NewFolderInput-button:disabled {
  background-color: var(--color_neutral_200) !important;
  color: var(--color_neutral_500) !important;
}
.NewFolderInput .NewFolderInput-button-wrapper .NewFolderInput-button:disabled svg path {
  stroke: var(--color_neutral_500);
}

.JobTitle-title-wrapper {
  text-align: left;
  color: var(--color_neutral_800);
}
.JobTitle-title-flex {
  display: flex;
  align-items: center;
  column-gap: 16px;
}
.JobTitle-title {
  font-size: 14px;
  font-weight: 400;
}
.JobTitle-title.active {
  color: var(--color_primary_500);
  font-weight: var(--bold_weight);
}
.JobTitle-subtitle {
  font-size: 12px;
  color: var(--color_neutral_500);
}

.JobPinsLimitStatus {
  font-size: 10px;
  font-weight: var(--regular_weight);
  color: var(--color_neutral_500);
}
.JobPinsLimitStatus::after {
  width: 175px !important;
  padding: 16px !important;
  font-size: 12px !important;
  text-align: left !important;
  white-space: normal !important;
}`, "",{"version":3,"sources":["webpack://./src/components/JobFolderAccordion/components/styles.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AACF;AACE;EACE,SAAA;EACA,kBAAA;AACJ;AAEE;EACE,aAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AADJ;AAGI;EACE,eAAA;EACA,kCAAA;EAEA,6BAAA;EACA,UAAA;AAFN;AAKI;EACE,eAAA;AAHN;AAKM;EACE,qDAAA;EACA,0CAAA;AAHR;AAMU;EACE,gCAAA;AAJZ;;AAaE;EACE,gBAAA;EACA,+BAAA;AAVJ;AAaE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAXJ;AAcE;EACE,eAAA;EACA,gBAAA;AAZJ;AAcI;EACE,+BAAA;EACA,+BAAA;AAZN;AAgBE;EACE,eAAA;EACA,+BAAA;AAdJ;;AAkBA;EACE,eAAA;EACA,kCAAA;EACA,+BAAA;AAfF;AAiBE;EACE,uBAAA;EACA,wBAAA;EAEA,0BAAA;EACA,2BAAA;EACA,8BAAA;AAhBJ","sourcesContent":[".NewFolderInput {\n  display: flex;\n  justify-content: space-between;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  padding-left: 12px;\n\n  &>div:first-child:not(.NewFolderInput-reachedLimit-container) {\n    flex: 1;\n    padding-left: 12px;\n  }\n\n  .NewFolderInput-actions-wrapper {\n    display: flex;\n  }\n\n  .NewFolderInput-button-wrapper {\n    display: flex;\n    align-items: center;\n    column-gap: 16px;\n\n    .NewFolderInput-limit {\n      font-size: 10px;\n      font-weight: var(--regular_weight);\n\n      transition: 0.16s ease-in-out;\n      opacity: 0;\n    }\n\n    .NewFolderInput-button {\n      font-size: 12px;\n\n      &:disabled {\n        background-color: var(--color_neutral_200) !important;\n        color: var(--color_neutral_500) !important;\n\n        svg {\n          path {\n            stroke: var(--color_neutral_500);\n          }\n        }\n      }\n    }\n  }\n}\n\n.JobTitle {\n  &-title-wrapper {\n    text-align: left;\n    color: var(--color_neutral_800);\n  }\n\n  &-title-flex {\n    display: flex;\n    align-items: center;\n    column-gap: 16px;\n  }\n\n  &-title {\n    font-size: 14px;\n    font-weight: 400;\n\n    &.active {\n      color: var(--color_primary_500);\n      font-weight: var(--bold_weight);\n    }\n  }\n\n  &-subtitle {\n    font-size: 12px;\n    color: var(--color_neutral_500);\n  }\n}\n\n.JobPinsLimitStatus {\n  font-size: 10px;\n  font-weight: var(--regular_weight);\n  color: var(--color_neutral_500);\n\n  &::after {\n    width: 175px !important;\n    padding: 16px !important;\n\n    font-size: 12px !important;\n    text-align: left !important;\n    white-space: normal !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
